import { Injectable } from '@angular/core';
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";


@Injectable()
export class AgedordersputwallService extends BaseService{

  constructor(private _commonService: CommonService,
    private _widgetHelper: WidgethelperService)   { 
      super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("BroadcastAgedOrdersPutwall").subscribe(
      (result: any) => {
        console.log("BroadcastAgedOrdersPutwall", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let hosSummary: any = result[0];
            this.addDataSeries(widget.chartOptions, 
              [
                hosSummary.LESS_THAN_5_HOURS_COUNT,
                hosSummary.BTW_5_AND_7_HOURS_COUNT,
                hosSummary.BTW_7_AND_10_HOURS_COUNT,
                hosSummary.BTW_10_AND_15_HOURS_COUNT,
                hosSummary.BTW_15_AND_24_HOURS_COUNT,
                hosSummary.GREATER_THAN_1_DAY_COUNT
              ], 'Aged Orders Putwall', 'bar');
              widget.chartOptions.xAxis.data = ['Below 5 Hrs', '5-7 Hrs', '7-10 Hrs', '10-15 Hrs', '15-24 Hrs', 'Above 24 Hrs'];          
            widget.errorMessage = null;
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
        
      },
      err => {
        console.log("listenFor broadcastAgedOrdersPutwall error", err);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/agedordersputwall.service.ts